import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["extensionInstalledInput", "extensionVersionInput"]
  }

  static get values() {
    return { extensionInstalled: Boolean, extensionVersion: String }
  }

  connect() {
    // To detect if the extension is installed and what version is installed, we have two
    // inputs that the extension fills with the right information. A timeout is set to
    // give the extension time to modify the DOM.
    setTimeout(() => {
      if (this.extensionInstalledInputTarget.value === "true" && this.extensionInstalledValue === false) {
        App.user.save({ installed_chrome_extension: true })

        // Google Universal Analytics
        App.analytics.ga_track("Extension", "Installation")

        // Google Analytics 4
        App.analytics.ga4_track("browser_extension_install")

        // Own analytics
        App.analytics.track("Chrome extension installed")
      }

      if (this.extensionVersionInputTarget.value !== this.extensionVersionValue) {
        App.user.save({ chrome_extension_version: this.extensionVersionInputTarget.value })
      }
    }, 3000)
  }
}
